import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from 'fronton-react';
import { Banner, HeaderSection, OtherSection } from 'common/components';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { useRegionIdSelector } from 'modules/model-json';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  AdviceSection,
  AssortmentSection,
  BathroomDesignPanel,
  BenefitsSection,
  OrderSection,
  ResultSection,
  SizingSection,
} from './components';
import {
  BATHROOM_CDN_PATH,
  BATHROOM_ELEMENT_BLOCK,
  BATHROOM_LANDING_NAME,
  getBathroomImageList,
} from './old-bathroom-constants';

/**
 * Вью страницы "Ванные комнаты"
 */
export const OldBathroom: React.FC = () => {
  const regionId = useRegionIdSelector();
  const designRegistrationHref = useMemo(() => `/zapis-onlayn/?department_no=6&region_id=${regionId}`, [
    regionId,
  ]);
  const { t } = useTranslation();
  const elementText = t('header.title');
  const isRuRegion = regionId !== KAZAKHSTAN;

  return (
    <>
      <HeaderSection
        imgList={getBathroomImageList(t)}
        bgColor="#438286"
        description={t('header.description')}
        mediaType="carousel"
        title={t('header.title')}
      />
      <BathroomDesignPanel designRegistrationHref={designRegistrationHref} />
      <Layout>
        <PromoBlock elementBlock={BATHROOM_ELEMENT_BLOCK} />
        <SpecialOffer elementBlock={BATHROOM_ELEMENT_BLOCK} />
        <OrderSection designRegistrationHref={designRegistrationHref} elementText={elementText} />
        {isRuRegion && (
          <Banner
            bgColor="#536074"
            elementBlock={`${BATHROOM_ELEMENT_BLOCK} / booster`}
            content={{
              media: {
                alt: t('banner-calculate.img-alt') || '',
                srcD: `${BATHROOM_CDN_PATH}/banner/bathroom-d.jpg/bathroom2-d.jpg`,
                srcT: `${BATHROOM_CDN_PATH}/banner/bathroom-t.jpg/bathroom2-t.jpg`,
                src: `${BATHROOM_CDN_PATH}/banner/bathroom-m.png/bathroom2-m.png`,
              },
              title: t('banner-calculate.title'),
              text: t('banner-calculate.text'),
            }}
            link={{
              href: '/kalkulyator-remonta/raschet-remonta-vannoy-komnaty/',
              target: '_blank',
              title: t('banner-calculate.link-title'),
            }}
            promotion={{
              name: BATHROOM_ELEMENT_BLOCK,
              creative: t('banner-calculate.title'),
              position: '1',
            }}
          />
        )}
        <AssortmentSection regionId={regionId} />
        {isRuRegion && <SizingSection />}
        <ResultSection regionId={regionId} />
        <BenefitsSection isRuRegion={isRuRegion} />
        {isRuRegion && (
          <Banner
            bgColor="#089FB0"
            elementBlock={`${BATHROOM_ELEMENT_BLOCK} / remont`}
            content={{
              media: {
                alt: t('banner-renovation.title') || '',
                srcD: `${BATHROOM_CDN_PATH}/banner-repair/banner-repair-d.jpg/banner-repair-d.jpg`,
                srcT: `${BATHROOM_CDN_PATH}/banner-repair/banner-repair-t.jpg/banner-repair-t.jpg`,
                src: `${BATHROOM_CDN_PATH}/banner-repair/banner-repair-m.png/banner-repair-m.png`,
              },
              title: t('banner-renovation.title'),
              text: t('banner-renovation.text'),
            }}
            link={{
              href: '/uslugi/remont-vannoy-komnaty/',
              title: t('banner-renovation.title'),
            }}
            promotion={{
              name: BATHROOM_ELEMENT_BLOCK,
              creative: t('banner-renovation.title'),
              position: '1',
            }}
          />
        )}
        {isRuRegion && <AdviceSection />}
      </Layout>
      <OtherSection
        elementBlock="landingVannuyuKomnatu / other"
        landingName={BATHROOM_LANDING_NAME}
        promotionName="vannuyuKomnatu_bottom"
      />
    </>
  );
};
